export enum ThemeEvent {
    ChangeTheme = 'Theme.ChangeTheme',
}
